import React from 'react'
import ReactTooltip from 'react-tooltip'
import classNames from 'classnames/bind'
import * as styles from './Tooltip.scss'

const cx = classNames.bind(styles)

interface IProps {
  id: string
  position?: 'top' | 'right' | 'bottom' | 'left'
  children?: any
  content?: any
  title?: any
}

const Tooltip: React.SFC<IProps> = (props) => {
  const { id, children, title, content, position } = props
  return (
    <>
      <a data-tip data-for={id}>{children ?? (<span className={styles.questionMark} />)}</a>
      <ReactTooltip className={styles.tooltip} id={id} place={position ?? 'left'} type='light' effect='solid'>
        <div>
          {title && (<div className={styles.title}>{title}</div>)}
          {content && (<div className={styles.content}>{content}</div>)}
        </div>
      </ReactTooltip>
    </>
  )
}

export default Tooltip
